import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { UPDATE_SPONSOR_SEARCH_MARKETING_PREFERENCE } from '@pass-frontend/common/data-access';
import { IMutation } from '@pass-frontend/data-access/common/edge';

export interface SponsorSearchMarketingPreferenceInput {
  sponsorName: string;
  sponsorId: string;
  eligibilityStatus: string;
  email?: string;
  optIn?: boolean;
}

export function useUpdateSponsorSearchMarketingPreference() {
  const [updateSponsorSearchMarketingPreference] = useMutation<
    Pick<IMutation, 'updateSponsorSearchMarketingPreference'>
  >(UPDATE_SPONSOR_SEARCH_MARKETING_PREFERENCE);

  const submitSponsorSearchMarketingPreference = useCallback(
    (variables: SponsorSearchMarketingPreferenceInput) =>
      updateSponsorSearchMarketingPreference({ variables }),
    [updateSponsorSearchMarketingPreference],
  );

  return { submitSponsorSearchMarketingPreference };
}
